import React from 'react';
import IconBase from './shared/icon-base';
import { jsx as ___EmotionJSX } from "@emotion/core";
export default function CopyIcon(props) {
  return ___EmotionJSX(IconBase, props, ___EmotionJSX("path", {
    d: "M16 17.5V19C16 20.6543 14.6543 22 13 22H5C3.3457 22 2 20.6543 2 19V11C2 9.3457 3.3457 8 5 8H6.5V10H5C4.44873 10 4 10.4482 4 11V19C4 19.5518 4.44873 20 5 20H13C13.5513 20 14 19.5518 14 19V17.5H16ZM22 13V5C22 3.3457 20.6543 2 19 2H11C9.3457 2 8 3.3457 8 5V13C8 14.6543 9.3457 16 11 16H19C20.6543 16 22 14.6543 22 13ZM19 4C19.5513 4 20 4.44824 20 5V13C20 13.5518 19.5513 14 19 14H11C10.4487 14 10 13.5518 10 13V5C10 4.44824 10.4487 4 11 4H19Z",
    fill: "currentColor"
  }));
}